const estimateRouter = [
  {
    path: '/estimate/index',
    name: 'estimateIndex',
    component: () => import('../views/estimate/index'),
    meta: {
      title: '预估',
    },
  },
  {
    path: '/sellingDishes/index',
    name: 'sellingDishes',
    component: () => import('../views/estimate/setUp/sellingDishes/index'),
    meta: {
      title: '设置销售主张菜品',
    },
  },
  {
    path: '/sellingDishes/selectDish',
    name: 'selectDish',
    component: () => import('../views/estimate/setUp/sellingDishes/selectDish'),
    meta: {
      title: '选择菜品',
    },
  },
  {
    path: '/reportForms/index',
    name: 'reportForms',
    component: () => import('../views/estimate/report/reportForms/index'),
    meta: {
      title: '预估报表',
    },
  },
  {
    path: '/reportForms/realityReportForms',
    name: 'realityReportForms',
    component: () => import('../views/estimate/report/reportForms/realityReportForms'),
    meta: {
      title: '营收预估与实际报表',
    },
  },
  {
    path: '/reportForms/reportFormsDifference',
    name: 'reportFormsDifference',
    component: () => import('../views/estimate/report/reportForms/reportFormsDifference'),
    meta: {
      title: '折前营收预估差异率',
    },
  },
  {
    path: '/reportForms/reportFormsDifferenceResult',
    name: 'reportFormsDifferenceResult',
    component: () => import('../views/estimate/report/reportForms/reportFormsDifferenceResult'),
    meta: {
      title: '菜品销售计划与实际差异份数',
    },
  },

  {
    path: '/estimate/revenue/index',
    name: 'estimateRevenueIndex',
    component: () => import('../views/estimate/revenue/index'),
    meta: {
      title: '营收预估结果',
    },
  },
  {
    path: '/estimate/revenue/visitDate',
    name: 'estimateRevenueVisitDate',
    component: () => import('../views/estimate/revenue/visitDate'),
    meta: {
      title: '调整参考日期',
    },
  },
  {
    path: '/estimate/revenue/salePlan',
    name: 'estimateRevenueSalePlan',
    component: () => import('../views/estimate/revenue/salePlan'),
    meta: {
      title: '制定菜品销售计划',
    },
  },
  {
    path: '/estimate/setUp',
    name: 'estimateSetUp',
    component: () => import('../views/estimate/setUp/index'),
    meta: {
      title: '预估设置 ',
    },
  },
  {
    path: '/estimate/setUp/eventManage',
    name: 'setUpEventManage',
    component: () => import('../views/estimate/setUp/eventManage/index'),
    meta: {
      title: '事件管理 ',
    }
  },
  {
    path: '/estimate/setUp/eventManage/calendar',
    name: 'setUpEventManageCalendar',
    component: () => import('../views/estimate/setUp/eventManage/calendarView'),
    meta: {
      title: '事件管理-日历 ',
    }
  },
  {
    path: '/estimate/setUp/eventManage/setEvent',
    name: 'setUpEventManageSetEvent',
    component: () => import('../views/estimate/setUp/eventManage/setEvent/index'),
    meta: {
      title: '设置事件 ',
    }
  },
  {
    path: '/estimate/setUp/referenceStore',
    name: 'setUpReferenceStore',
    component: () => import('../views/estimate/setUp/referenceStore/index'),
    meta: {
      title: '对标门店 ',
    }
  },
  {
    path: '/estimate/setUp/referenceStore/setBench',
    name: 'setUpReferenceStoreSetBench',
    component: () => import('../views/estimate/setUp/referenceStore/setBench/index'),
    meta: {
      title: '设置对标门店 ',
    }
  },
  {
    path: '/estimate/setUp/referenceStore/calendarView',
    name: 'setUpReferenceStoreCalendarView',
    component: () => import('../views/estimate/setUp/referenceStore/calendarView/index'),
    meta: {
      title: '对标门店详情 ',
    }
  },
  {
    path: '/estimate/revenue/setSaleDish',
    name: 'estimateRevenueSetSaleDish',
    component: () => import('../views/estimate/revenue/setSaleDish'),
    meta: {
      title: '设置销售主张菜品 ',
    }
  },
  {
    path: '/estimate/revenue/revenueResult',
    name: 'estimateRevenueRevenueResult',
    component: () => import('../views/estimate/revenue/revenueResult'),
    meta: {
      title: '营收预估结果 ',
    }
  },
  {
    path: '/estimate/setDish',
    name: 'setDish',
    component: () => import('../views/estimate/setUp/setDish/index.vue'),
    meta: {
      title: '设置菜品见台率 ',
    },
  },
]

export default estimateRouter
